import React, { useEffect } from "react";

const UpgradePopup = () => {
  const [show, setShow] = React.useState(true);
  return (
    <div
      className="d-flex justify-content-center align-items-center bg-gradient"
      style={{
        background:
          "linear-gradient(to bottom right, #e0e7ff, #f5e1ff, #ffe1ec)",
      }}
    >
      {" "}
      <div
        className={`modal fade ${show ? "show d-block" : ""}`}
        tabIndex="-1"
        style={{ backgroundColor: show ? "rgba(0,0,0,0.5)" : "transparent" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg modal-sm" 
        style={{ maxWidth: '500px'}}>
          <div
            className="modal-content text-center text-white rounded-4 shadow-lg border-0"
            style={{ backgroundColor: "#6059f7" }}
          >
            <button
              type="button"
              className="btn-close btn-close-white position-absolute top-0 end-0 m-3"
              aria-label="Close"
              onClick={() => {
                window.location.href = "https://newlib.storyworld.io";
              }}
            ></button>
            <div className="mt-4 d-flex justify-content-center mb-3">
              <img
                src="/storyworld-logo-2.svg"
                alt="Profile"
                style={{ width: "96px", height: "96px", objectFit: "cover" }}
              />
            </div>

            <div className="px-4 pb-3">
              <h4 className="fw-semibold">Oops! This feature is available</h4>
              <h4 className="fw-semibold">with a Premium subscription!</h4>
              <p
                className="mt-2 opacity-75"
                style={{
                  fontSize: "1.2em",
                }}
              >
                Upgrade your subscription to access all features.
              </p>

              <div className="row g-2 mt-3">
                <div className="col-6">
                  <button
                    type="button"
                    className="
                  btn text-white fw-semibold py-2 w-100
                  "
                    style={{
                      backgroundColor: "#4d35dc",
                      fontWeight: "bold",
                    }}
                    onClick={() => {
                      window.location.href = "https://next.storyworld.io/home?tab=billing";
                    }}
                  >
                    Upgrade now
                  </button>
                </div>
                <div className="col-6">
                  <button
                    type="button"
                    className="btn text-white py-2 w-100"
                    style={{ backgroundColor: "#ff5757", fontWeight: "bold" }}
                    onClick={() => {
                      window.location.href =
                        "https://docs.google.com/forms/d/e/1FAIpQLSdxs83PGNC4eMixO4Mh9Q-SKun_oXxeFagD2QMYm2DbiYBZvw/viewform";
                    }}
                  >
                    Request a quote
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradePopup;
